import { makeStyles, tokens } from '@fluentui/react-components';

export const useDatePickerStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXS,
    // Allow the underlying Fluent compat DatePicker (an Input under the hood)
    // to shrink below its default 250px min-inline-size when laid out in a
    // narrow grid cell, otherwise it overflows and overlaps neighbouring
    // fields at smaller desktop widths.
    minWidth: 0,
    '& .fui-Input': {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      boxSizing: 'border-box',
    },
    '& .fui-Input__input': {
      minWidth: 0,
    },
  },
});
